"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterAndCopyright = void 0;
const organism_1 = require("./organism");
const props_1 = require("../common/props");
/**
 * The footer and copyright organism.
 * @category Organisms
 */
class FooterAndCopyright extends organism_1.Organism {
    constructor(organisms) {
        super("Footer And Copyright", organisms);
        this.footerBackground = new props_1.PropertyStringSelectable("Footer background", false, this, {
            selectables: ["Primary 800/Primary 900", "Primary 800/Primary 900"] // TODO: Shouldn't be duplicate selectable values
        });
        this.footerVerticalPadding = new props_1.PropertyNumberSelectable("Footer vertical padding", false, this, [0.5, 1, 2, 3, 4, 5, 6], 5);
        this.copyrightVerticalPadding = new props_1.PropertyNumberSelectable("Copyright vertical padding", false, this, [0.5, 1, 2, 3], 2);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.footerBackground.deserialize(obj.footerBackground);
        this.footerVerticalPadding.deserialize(obj.footerVerticalPadding);
        this.copyrightVerticalPadding.deserialize(obj.copyrightVerticalPadding);
    }
    serialize() {
        const obj = {};
        obj.footerBackground = this.footerBackground.serialize();
        obj.footerVerticalPadding = this.footerVerticalPadding.serialize();
        obj.copyrightVerticalPadding = this.copyrightVerticalPadding.serialize();
        return obj;
    }
}
exports.FooterAndCopyright = FooterAndCopyright;
